module.exports = __webpack_public_path__ + "static/icon_instagram-1f0b9b2264ac40e165888df179b379d4.png";